/**
 * State used in rendering TableResizeHandle
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
